export const text = {
  emailPlaceholder: "Enter Email",
  subscribe: "Subscribe",
};
